module.exports = __webpack_public_path__ + "img/L.30c453b7.png";